import * as React from "react";
import "./HabitSummary.css";
import { LinkContainer } from "react-router-bootstrap";
import { Habit } from "habits/types";
import { getHabitUrl } from "habits/util";

export default function HabitSummary(props: {
  isComplete: boolean;
  habit: Habit;
}) {
  const url = getHabitUrl(props.habit.destination, props.habit.habitId);

  const completionIcon = props.isComplete ? "✅" : "➕";
  return (
    <LinkContainer to={url}>
      <div className="HabitSummaryContainer">
        <span className="HabitSummaryTitle">
          {completionIcon} {props.habit.title}
        </span>
        <span className="HabitSummaryDescription">
          {props.habit.description}
        </span>
      </div>
    </LinkContainer>
  );
}
